import React, {PropTypes} from 'react';
import Consts from '../../../Consts';

class FieldGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"o-fieldGroup"+(this.props.valid?"":" has-error")+(this.props.hide?" u-display-none":"")}>
                <div className="c-InputContainer">
                    <label htmlFor="name" className="c-Label">{this.props.label}</label>
                    {this.props.children}
                    {this.props.children.type == 'select'?<img className="c-Input-dropdownArrows " src={Consts.baseDir+"/images/dropdown-triangles.png"}/>:''}
                </div>
                <div className="c-InlineText c-InlineText--error">{this.props.errorText}</div>
            </div>                
        );
    }
}

FieldGroup.propTypes = {
    label: React.PropTypes.string.isRequired,
    errorText: React.PropTypes.string.isRequired,
    valid: React.PropTypes.bool.isRequired,
    hide: React.PropTypes.bool
};


export default FieldGroup;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/FieldGroup.js
 **/